import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImagePreviewService {
  readonly url = signal<string | null>(null);

  open(url: string | null | undefined, event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    const src = (url || '').trim();
    if (!src) return;
    this.url.set(src);
  }

  close(): void {
    this.url.set(null);
  }
}
